import { UserModel } from '@/types';

export interface UserQueueStatusHistoryModel {
    id: number;
    userId: number;
    user?: UserModel;
    pausedAt: Date;
    unpausedAt: Date;
    date: Date;
    createdAt: Date;
}
